import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Wrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	background-color: rgba(0, 0, 0, 0.8);
	align-items: center;
	justify-content: center;
	padding: 2em;

	p {
		padding: 2em 4em;
		background-color: #fff;
		color: ${props => props.theme.main.bg};
		display: inline-block;
		border-radius: 3px;
		font-size: 1.2em;
	}
`

const ContactModal = ({ message }) => (
	<Wrapper>
		<p>{message}</p>
	</Wrapper>
)

ContactModal.propTypes = {
	message: PropTypes.string.isRequired
}

export default ContactModal


// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/contact/ContactModal.js